module.exports = __webpack_public_path__ + "img/gal_20.c82879db.png";